export default {
  name: 'HierarchiesPivotTableFilters',
  data () {
    return {}
  },
  computed: {}
}
